import { api } from '@/lib/api/client';

export interface SaasParams {
  maintenanceModeFront: boolean;
  maintenanceModeAdmin: boolean;
  openRegister: boolean;
  openCompetitionRegistration: boolean;
  referralEnabled: boolean;
  playerPlusEnabled: boolean;
  maintenanceMessage: string | null;
  updatedAt: string;
}

export interface UpdateSaasParamsDto {
  maintenanceModeFront?: boolean;
  maintenanceModeAdmin?: boolean;
  openRegister?: boolean;
  openCompetitionRegistration?: boolean;
  referralEnabled?: boolean;
  playerPlusEnabled?: boolean;
  maintenanceMessage?: string | null;
}

/** Endpoint public — aucune auth requise. */
export async function getSaasParams(): Promise<SaasParams> {
  return api.get('/saas-params');
}

/** Endpoint SUPER_ADMIN — token injecté automatiquement par le client. */
export async function updateSaasParams(dto: UpdateSaasParamsDto): Promise<SaasParams> {
  return api.patch('/saas-params', dto);
}
